import React, { FC } from 'react';

import clsx from 'clsx';

import { StyledCheckbox } from '@components/common/StyledCheckbox/StyledCheckbox';

import styles from './StyledCheckboxWithLabel.module.scss';

type ClassKey = 'root' | 'label';

export type StyledCheckboxWithLabelProps = Readonly<{
    label: string;
    onChange?(value: boolean): void;
    isChecked?: boolean;
    classes?: Classes<ClassKey>;
}>;

export const StyledCheckboxWithLabel: FC<StyledCheckboxWithLabelProps> = (props) => {
    const { label, classes, onChange, isChecked } = props;

    return (
        // Radix checkbox renders a button - a control,
        // but it is not recognized by this disabled lint.
        // eslint-disable-next-line jsx-a11y/label-has-associated-control
        <label className={clsx(styles.root, classes?.root)}>
            <StyledCheckbox value={isChecked} onChange={onChange} className={styles.control} />
            <span className={clsx(styles.label, classes?.label)}>{label}</span>
        </label>
    );
};
